import React from 'react';

// Types
import { MetricSlugs } from '../../ManagerDashboardData.constants';

// Constants
import ColorConstants from 'Wpds/colors/ColorConstants';

// Components
import { usePopover, WpPopoverOverlay } from 'Wpds/components/popover';
import MetricsWrapper from '../MetricsWrapper';
import WpDataTable from 'Wpds/components/table/WpDataTable';

// Styles
import './RelationshipCadence.scss';

type Props = {
  relationshipCadence;
};

const RelationshipCadence = ({ relationshipCadence }: Props) => {
  const dayValues = [];
  const transformedData = [];

  relationshipCadence.forEach(user => {
    for (const [key, value] of Object.entries(user)) {
      const newUserData = user;
      if (key.startsWith('day_')) {
        const total = Object.values(value).reduce((a, b) => a + b, 0);
        dayValues.push(total);
        newUserData[`${key}_total`] = total;
      }
    }
    transformedData.push(user);
  });

  const baseClassName = 'RelationshipCadence';

  const CellComponent = ({ row, selector }) => {
    const popover = usePopover({
      event: 'hover',
    });
    const max = Math.max(...dayValues);
    const selectorValue = row[`${selector}_total`];
    const percentage = (selectorValue / max) * 100;

    const getScale = () => {
      if (percentage > 80) {
        return 'scale(2.25)';
      } else if (percentage > 60) {
        return 'scale(2)';
      } else if (percentage > 40) {
        return 'scale(1.75)';
      } else if (percentage > 20) {
        return 'scale(1.5)';
      } else if (percentage > 0) {
        return 'scale(1.25)';
      }

      return 'scale(1)';
    };

    const bgColor = percentage > 0 ? ColorConstants.blue[500] : null;
    return (
      <>
        <div className={`${baseClassName}__indicator-wrapper`}>
          <div
            className={`${baseClassName}__indicator-wrapper__indicator`}
            style={{ transform: getScale(), backgroundColor: bgColor }}
            ref={popover.targetRef}
          />
        </div>
        <WpPopoverOverlay context={popover}>
          <p>Group Workspaces: {row[selector].group_activity}</p>
          <p>1:1 Workspace: {row[selector].one_on_one_activity}</p>
        </WpPopoverOverlay>
      </>
    );
  };

  return (
    <MetricsWrapper slug={MetricSlugs.interactions_with_teammates}>
      <div className={baseClassName}>
        <WpDataTable
          columns={[
            { name: 'Team member', selector: 'report_name', noWrap: true },
            { name: 'Frequency', selector: 'frequency' },
            { name: 'Mon', selector: 'day_0', component: CellComponent },
            { name: 'Tues', selector: 'day_1', component: CellComponent },
            { name: 'Wed', selector: 'day_2', component: CellComponent },
            { name: 'Thur', selector: 'day_3', component: CellComponent },
            { name: 'Fri', selector: 'day_4', component: CellComponent },
          ]}
          rows={relationshipCadence}
          enableSort={false}
        />
      </div>
    </MetricsWrapper>
  );
};

export default RelationshipCadence;
